type Historical = {
  refetching: boolean;
  firstTotalPnL: number;
  lastTotalPnl: number;
  firstNonZeroEquity: number;
  lastEquity: number;
};

type Recent = {
  refetching: boolean;
  equity: string;
};

type Calculated =
  | {
      last24hPnLAmount: number;
      last24hPnLPercentage: number;
    }
  | false;

/**
 * How is PnL calculated in other products:
 * https://www.binance.com/en/support/faq/how-are-pnl-calculated-on-binance-futures-and-options-pnl-analysis-dbb171c4db1e4626863ec8bc545be46a
 * https://www.bybit.com/en/help-center/article/Profit-Loss-calculations-Inverse-Contracts#Unrealizedpl
 */
export function calculateWalletLast24hStat(
  /** Historical PnL API response data */
  historical?: Historical,
  recent?: Recent
): Calculated {
  // Hide data when loading - it might be because new deposit/withdrawal
  // which would cause data look incorrect
  if (historical === undefined || !recent || historical.refetching) {
    return false;
  }

  const recentEquity = Number(recent.equity);
  const equityDiff = recentEquity - historical.lastEquity;

  /** Last known PnL & live-data correction from positions endpoint */
  const last24hPnLAmount =
    historical.lastTotalPnl - historical.firstTotalPnL + equityDiff;

  const last24hPnLPercentage = !historical.firstNonZeroEquity
    ? 0
    : (last24hPnLAmount / historical.firstNonZeroEquity) * 100;

  return {
    last24hPnLAmount,
    last24hPnLPercentage,
  };
}
